// extracted by mini-css-extract-plugin
module.exports = {"footer":"components-Footer-Footer__footer--HJlsB"};